/* eslint-disable */
import moment from 'moment'
import * as jsPDF from 'jspdf'
import 'jspdf-autotable'
import { retornaStringDataParaDDMMYYYY } from '@/utils/data.utils'
import Cargos from '@/models/Cargos'

const ALIGN_ESQ = 30

const retornaDataFormatada = data => moment.tz(data, 'America/Sao_Paulo').format('DD/MM/YYYY')

export default class GerarPdfFechamentoCaixa {
  constructor(context) {
    this.context = context
    this.dadosLancamentos = null
    this.colunasTabela = []
    this.documento = this._configuracoesDocumento()
    this._configuracoesPagina()
  }

  _mostrarCampos() {
    const { usuario } = this.dadosLancamentos
    if (usuario) {
      return usuario.role === Cargos.ADMINISTRADOR
    }

    return false
  }

  _configuracoesDocumento() {
    const doc = new jsPDF('landscape')
    doc.setTextColor(100)
    doc.setDrawColor(100)
    doc.setFontSize(10)

    return doc
  }

  _configuracoesPagina() {
    this.pageWidth = this.documento.internal.pageSize.width
    this.baseTop = 10
    this.baseEsq = 10
  }

  _gerarCabecalho() {
    const { usuario, filial, periodo } = this.dadosLancamentos

    this.documento.text(`Filial: ${filial}`, this.baseEsq + 5, this._pulaLinha())
    this.documento.text(`Data: ${retornaDataFormatada(new Date())}`, this.pageWidth - 20, this.baseTop, 'right')
    this.documento.text(`Responsável: ${usuario.nome}`, this.baseEsq + 5, this._pulaLinha())

    this.documento.setLineWidth(1)
    this.documento.line(this.baseEsq + 5, this.baseTop + 5, this.pageWidth - 20, this.baseTop + 5)

    this.baseTop += 20
    this.documento.setFontType('bold');
    this.documento.setFontSize(22)
    this.documento.text('Fechamento de caixa', this.pageWidth / 2, this.baseTop, 'center')

    this.documento.setFontType('normal')
    this.documento.setFontSize(10)
    this.baseTop += 6

    const dtIni = retornaStringDataParaDDMMYYYY(periodo.dataInicial)
    const dtFim = retornaStringDataParaDDMMYYYY(periodo.dataFinal)
    this.documento.text(`Período de ${dtIni} até ${dtFim}`, this.pageWidth / 2, this.baseTop, 'center')
  }

  _gerarColunaProdutos() {
    const { itens } = this.dadosLancamentos

    const colunas = this.colunasTabela.map(coluna => {
      return {
        title: coluna.label,
        dataKey: coluna.key,
      }
    })

    const objMascara = itens.map(item => {
      item.totalpagar = `R$ ${this.context.$options.filters.currency(
        item.totalpagar,
        '',
      )}`

      return item
    })

    this.documento.autoTable(colunas, objMascara, {
      showHead: 'everyPage',
      startY: this.baseTop + 10,
      margin: { left: this.baseEsq },
      theme: 'striped',
      headStyles: { fillColor: [100], lineColor: [0, 0, 60] },
      bodyStyles: { lineColor: [30, 30, 30] },
      styles: {
        lineColor: 200,
        startY: this.baseEsq,
        fontSize: 5,
      },
    })
  }

  _gerarTotalizador() {
    const { totalizador } = this.dadosLancamentos

    this.baseTop = this.documento.autoTable.previous.finalY
    this.baseTop += 10
    this.documento.text(
      this.pageWidth - 15,
      this.baseTop,
      `Total geral: R$ ${this.context.$options.filters.currency(totalizador.totalGeral, '')}`,
      'right',
    )

    this.baseTop += 5
    this.documento.text(
      this.pageWidth - 15,
      this.baseTop,
      `Total em dinheiro: R$ ${this.context.$options.filters.currency(totalizador.totalDinheiro, '')}`,
      'right',
    )

    this.baseTop += 5
    this.documento.text(
      this.pageWidth - 15,
      this.baseTop,
      `Total em cartão: R$ ${this.context.$options.filters.currency(totalizador.totalCartao, '')}`,
      'right',
    )

    
    if(this._mostrarCampos()){
      this.baseTop += 5
      this.documento.text(
        this.pageWidth - 15,
        this.baseTop,
        `Total barbeiros: R$ ${this.context.$options.filters.currency(totalizador.totalBarbeiros, '')}`,
        'right',
      )
    }
    
    if(this._mostrarCampos()){
      this.baseTop += 5
      this.documento.text(
        this.pageWidth - 15,
        this.baseTop,
        `Total líquido: R$ ${this.context.$options.filters.currency(totalizador.totalLiquido, '')}`,
        'right',
      )
    }
    
  }

  _gerarConteudo() {
    this._gerarColunaProdutos()
    this._gerarTotalizador()
  }

  _apresentaPdf() {
    const { filial, usuario, periodo } = this.dadosLancamentos

    this.documento.save(`fechamento_de_caixa_${usuario.nome}_${filial}_${periodo.dataInicial}_${periodo.dataFinal}`)
    window.open(URL.createObjectURL(this.documento.output('blob')))
  }

  _pulaLinha() {
    this.baseTop = this.baseTop + 5
    return this.baseTop
  }

  gerarPdf(dados, colunas) {
    if (dados) {
      this.dadosLancamentos = JSON.parse(JSON.stringify(dados))
      this.colunasTabela = colunas
      this._gerarCabecalho()
      this._gerarConteudo()

      this._apresentaPdf()
    }
  }
}
